import { render, staticRenderFns } from "./safetyAndEnvironmentDialog.vue?vue&type=template&id=7f530cd6&scoped=true&"
import script from "./safetyAndEnvironmentDialog.vue?vue&type=script&lang=ts&"
export * from "./safetyAndEnvironmentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./safetyAndEnvironmentDialog.vue?vue&type=style&index=0&id=7f530cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f530cd6",
  null
  
)

export default component.exports